<template>
  <div>
    <router-link to="/dashboard/recruiting-process"
      ><button class="btn link">
        <i class="las la-angle-left"></i>Go Back
      </button></router-link
    >
    <h3 class="dashboard-title">Candidate Information</h3>
    <div class="candidate-brief">
      <div class="row">
        <div class="info">
          <div class="name">
            <h4>Name</h4>
            <span>John Doe</span>
          </div>
          <div class="salary">
            <h4>Expected Salary</h4>
            <span>30,000 - 35,000 THB</span>
          </div>
        </div>
        <div class="status">
          <span class="pill">employed</span>
        </div>
      </div>
      <div class="reason">
        <div class="info-text">
          <h4>Reasons for your recommendation</h4>
          <ul class="text-list">
            <li>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel qui,
              impedit nostrum aspernatur beatae hic nihil animi quaerat totam
              consequatur Lorem ipsum dolor sit amet consectetur adipisicing
              elit. Quo, cupiditate eos dolor accusamus nobis earum voluptatibus
              sed, nulla delectus ipsum obcaecati voluptatem qui exercitationem
              non deserunt rem alias illo distinctio!.
            </li>
            <li>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel qui,
              impedit nostrum aspernatur beatae hic nihil animi quaerat totam
              consequatur.
            </li>
            <li>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel qui,
              impedit nostrum aspernatur beatae hic nihil animi quaerat totam
              consequatur.
            </li>
          </ul>
        </div>
      </div>
      <div class="download-btn">
        <a class="btn btn-outline" href="#">Download CV</a>
      </div>
    </div>
    <div class="separator"></div>
    <h3 class="dashboard-title">Job Information</h3>
    <div class="job-list">
      <div class="job-item">
        <div class="left">
          <div class="position">
            <h2>Purchasing Coordinator (Middle Level)</h2>
          </div>
          <div class="location">
            <i class="las la-map-marker"></i
            ><span
              >BTS (Chidlom) , MRT Lines Lorem ipsum dolor sit amet consectetur
              adipisicing elit. Consectetur molestiae perspiciatis ipsa ad sunt
              sint vitae deserunt dolorum
            </span>
          </div>
          <div class="salary">
            <i class="las la-money-bill"></i
            ><span>35,000 THB - 50,000 THB</span>
          </div>
          <div class="post-date">
            <i class="las la-clock"></i><span>11 hours ago</span>
          </div>
        </div>
        <div class="right">
          <div class="jobid">Job ID: 123456</div>
        </div>
      </div>
    </div>
    <div class="job-info">
      <ul class="list">
        <li class="category">
          <div class="heading">Job Category</div>
          <div class="info-text">
            Network Engineer (Design), Network Engineer (Operation/Maintenance),
            Support/Maintenance/Operation/Training
          </div>
        </li>
        <li class="company">
          <div class="heading">Industry</div>
          <div class="info-text">
            Network Engineer (Design), Network Engineer (Operation/Maintenance),
            Support/Maintenance/Operation/Training
          </div>
        </li>
        <li class="job-description">
          <div class="heading">Job Description</div>
          <div class="info-text">
            <ul class="text-list">
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                totam consequatur Lorem ipsum dolor sit amet consectetur
                adipisicing elit. Quo, cupiditate eos dolor accusamus nobis
                earum voluptatibus sed, nulla delectus ipsum obcaecati
                voluptatem qui exercitationem non deserunt rem alias illo
                distinctio!.
              </li>
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                totam consequatur.
              </li>
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                totam consequatur.
              </li>
            </ul>
          </div>
        </li>
        <li class="requirement">
          <div class="heading">Requirement</div>
          <div class="info-text">
            <ul class="text-list">
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                totam consequatur Lorem ipsum dolor sit amet consectetur
                adipisicing elit. Quo, cupiditate eos dolor accusamus nobis
                earum voluptatibus sed, nulla delectus ipsum obcaecati
                voluptatem qui exercitationem non deserunt rem alias illo
                distinctio!.
              </li>
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                totam consequatur.
              </li>
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel
                qui, impedit nostrum aspernatur beatae hic nihil animi quaerat
                totam consequatur.
              </li>
            </ul>
          </div>
        </li>
        <li class="intencive">
          <div class="heading">Incentive</div>
          <div class="info-text">
            <ul class="text-list">
              <li>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam,
                incidunt!
              </li>
              <li>Lorem ipsum dolor sit amet.</li>
            </ul>
          </div>
        </li>
        <li class="benefit">
          <div class="heading">Benefit</div>
          <div class="info-text">
            <ul class="text-list">
              <li>Provident Fund</li>
              <li>Annual Health Checkup</li>
            </ul>
          </div>
        </li>
        <li class="working-hour">
          <div class="heading">Working Houre</div>
          <div class="info-text">8:00 - 17:30</div>
        </li>
        <li class="holiday">
          <div class="heading">Holiday</div>
          <div class="info-text">
            <ul class="text-list">
              <li>Weekend</li>
              <li>Holiday</li>
            </ul>
          </div>
        </li>
        <li class="company-website">
          <div class="heading">Company Website</div>
          <div class="info-text">
            <a href="#" class="link" target="_blank"
              >https://www.reeracoen.co.th/</a
            >
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "DashboardProcessDetails",
  data() {
    return {
      fields: [
        { key: "name", label: "Candidate Name" },
        { key: "salary", label: "Expected Salary" },
        { key: "status", label: "Status" },
      ],
      items: [
        {
          name: { first: "John", last: "Doe" },
          salary: "30,000 - 35,000",
          status: "reviewing",
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
.link {
  background: transparent;
  color: $black;
  font-size: 14px;
  margin-bottom: 1rem;
  padding: 0;
  i {
    margin-right: 8px;
  }
  &:hover,
  &:focus {
    filter: opacity(70%);
  }
}
.candidate-brief {
  margin-bottom: 1rem;
  .row {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 1rem;
    .info {
      align-items: flex-start;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 70%;

      .name,
      .salary {
        h4 {
          color: $black;
          font-size: 1em;
          margin-bottom: 0.5rem;
        }
        span {
          color: $black;
          font-size: 1.15em;
          font-weight: 500;
          line-height: 1.5rem;
        }
      }
      .name {
        width: 50%;
      }
      .salary {
        width: 50%;
      }
    }
    .status {
      width: 30%;
      .pill {
        background: $status-employed;
        border-radius: 100rem;
        color: $white;
        display: inline;
        font-size: 12px;
        font-weight: 700;
        padding: 5px 10px;
        text-transform: uppercase;
        width: auto;
      }
    }
  }
  .reason {
    margin-bottom: 1rem;
    h4 {
      color: $black;
      font-size: 1em;
      margin-bottom: 0.5rem;
    }
    .info-text {
      color: $black;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
        "Segoe UI Symbol";
      font-size: 14px;

      .text-list {
        list-style-type: disc;
        padding-left: 1.2rem;
        li {
          line-height: 1.5rem;
          margin-bottom: 5px;
        }
      }
    }
  }
  .download-btn {
    .btn {
      display: inline-flex;
    }
  }
}

.job-list {
  .job-item {
    align-items: stretch;
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
    padding: 0;
    width: 100%;
    .left {
      flex: auto;
      width: 70%;
      .position {
        margin-bottom: 0.5rem;
        h2 {
          font-size: 1.25em;
        }
      }
      .location,
      .salary,
      .post-date {
        align-items: flex-start;
        display: flex;
        flex-direction: row;
        line-height: 1.75rem;

        i {
          color: $blue-primary;
          font-size: 20px;
          margin-right: 10px;
          margin-top: 3px;
        }
        span {
          color: $black;
          font-size: 1em;
          font-weight: 500;
        }
      }
      .salary {
        span {
          font-weight: 700;
        }
      }
      .post-date {
        i {
          color: $gray;
          font-size: 16px;
          margin-right: 10px;
          margin-top: 3px;
        }
        span {
          color: $gray;
          font-size: 12px;
          font-weight: normal;
        }
      }
    }
    .right {
      align-items: flex-end;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 30%;
      .jobid {
        color: $gray;
        font-size: 1.15em;
        font-weight: 700;
      }
      .button {
        .btn {
          border: 1px solid $black;
          color: $black;
          display: inline-flex;
          flex-direction: column;
          line-height: 5px;
          padding: 15px 15px 10px 15px;
          i {
            font-size: 18px;
          }
          span {
            font-size: 14px;
          }
        }
      }
    }
  }
}
.job-info {
  margin-bottom: 2rem;
  .list {
    li {
      margin-bottom: 1.5rem;
      .heading {
        color: $black;
        font-size: 1em;
        font-weight: 700;
        margin-bottom: 0.5rem;
      }
      .info-text {
        color: $black;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
          Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
          "Segoe UI Symbol";
        font-size: 14px;
        line-height: 1.5rem;

        .text-list {
          list-style-type: disc;
          padding-left: 1.2rem;
          li {
            font-size: 14px;
            line-height: 1.5rem;
            margin-bottom: 5px;
          }
        }
      }
      .link {
        color: $black;
        text-decoration: underline;
        &:hover,
        &:focus {
          color: $black;
        }
      }
    }
  }
}
.separator {
  border-bottom: 1px solid $gray;
  display: block;
  margin-bottom: 2rem;
  margin-top: 2rem;
  padding: 0;
}

@media only screen and (max-width: 991px) {
  .candidate-brief {
    .row {
      .info {
        display: flex;
        flex-direction: column;
        width: 60%;

        .name,
        .salary {
          h4 {
            font-size: 14px;
          }
          span {
            font-size: 14px;
          }
        }
        .name {
          margin-bottom: 0.5rem;
          width: 100%;
        }
        .salary {
          width: 100%;
        }
      }
      .status {
        text-align: right;
        width: 40%;
      }
    }
    .reason {
      margin-bottom: 1rem;
      h4 {
        font-size: 14px;
      }
    }
  }

  .job-list {
    .job-item {
      display: flex;
      flex-direction: column;
      margin-bottom: 1rem;
      padding: 0;
      .left {
        width: 100%;
        .position {
          h2 {
            font-size: 1.15em;
          }
        }
        .location,
        .salary,
        .post-date {
          line-height: 1.5rem;

          i {
            font-size: 16px;
            margin-right: 8px;
            margin-top: 3px;
          }
          span {
            font-size: 12px;
          }
        }
        .post-date {
          i {
            font-size: 14px;
            margin-right: 5px;
          }
          span {
            font-size: 10px;
          }
        }
      }
      .right {
        align-items: flex-start;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 5px;
        width: 100%;
        .jobid {
          font-size: 12px;
        }
        .button {
          .btn {
            line-height: 5px;
            padding: 10px 10px 5px 10px;
            i {
              font-size: 14px;
            }
            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .job-info {
    .list {
      li {
        margin-bottom: 1.5rem;
        .heading {
          font-size: 14px;
        }
        .info-text {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
